import mime from 'mime';

export const getFileExtensionsFromMimeType = (type: string): string[] => {
    const result = mime.getAllExtensions(type);

    if (!result) {
        return [];
    }

    return Array.from(result);
};
